window.Products.Clothing.PremiumPulloverHoodie = function() {
};
window.Products.Clothing.PremiumPulloverHoodie.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.PremiumPulloverHoodie.dpi = 150;
window.Products.Clothing.PremiumPulloverHoodie.has_3d = true;
window.Products.Clothing.PremiumPulloverHoodie.id = 114;
window.Products.Clothing.PremiumPulloverHoodie.slug = 'premium-pullover-hoodie';
window.Products.Clothing.PremiumPulloverHoodie.syncColors = true;
window.Products.Clothing.PremiumPulloverHoodie.texturesLoaded = 0;
window.Products.Clothing.PremiumPulloverHoodie.texturesLoading = false;
window.Products.Clothing.PremiumPulloverHoodie.use_glb = true;

window.Products.Clothing.PremiumPulloverHoodie.prototype.outsideObject = 0;
window.Products.Clothing.PremiumPulloverHoodie.prototype.detailsObject = 1;
window.Products.Clothing.PremiumPulloverHoodie.prototype.position = 0.1;

window.Products.Clothing.PremiumPulloverHoodie.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather") || color == "sport_grey"){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.PremiumPulloverHoodie.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"forest_green": 0x3a4634,
		"dark_heather": 0x414143,
		"ivory": 0xd8d3c2,
		"kiwi": 0x879f85,
		"lavender": 0xb8abd0,
		"maroon": 0x6c192c,
		"peach": 0xebcbae,
		"pink": 0xe5bdca,
		"sky_blue": 0xa3bddd,
		"navy_blue": 0x363646,
		"royal_blue": 0x1e6fbf,
		"sport_grey": 0xb7b3be,
	};

	return new THREE.Color(colors[_name]);
};